import { Navigate } from "react-router-dom";
import { routes } from "../helpers/constants";
import LoginPage from "../pages/Login/LoginPage";
import Dashboard from "../pages/Dashboard";
import Company from "../pages/Company";
import CompanyItemList from "../pages/Company/CompanyItemList";
import CompanyItemDetails from "../pages/Company/CompanyItemDetails";
import CompanyItemStart from "../pages/Company/CompanyItemStart";
import SiphoningStep from "../pages/SiphoningStep";
import SiphoningSummary from "../pages/SiphoningStep/SiphoningSummary";
import SummaryNotes from "../pages/SiphoningStep/SiphoningSummary/SummaryNotes";
import ReportItemDetails from "../pages/Report/ReportItemDetails";
import BrowserCompatibility from "../pages/BrowserCompatibility/BrowserCompatibility";
import Sync from "../pages/Sync/Sync";
import ReportList from "../pages/Report";

export const compatibilityRoutes = [
  {
    path: routes.homepage,
    element: <Navigate to={routes.browserCompatibility} />,
  },
  { path: routes.browserCompatibility, element: <BrowserCompatibility /> },
];

export const authRoutes = [
  { path: routes.homepage, element: <Navigate to={routes.login} /> },
  { path: routes.login, element: <LoginPage /> },
];

export const syncRoutes = [
  { path: routes.homepage, element: <Navigate to={routes.sync} /> },
  { path: routes.sync, element: <Sync /> },
];

export const mainRoutes = [
  {
    path: routes.homepage,
    element: <Navigate to={routes.dashboard} />,
  },

  // COMPANY PAGES
  { path: routes.dashboard, element: <Dashboard /> },
  { path: routes.company, element: <Company /> },
  { path: routes.companyItemList, element: <CompanyItemList /> },
  { path: routes.companyItemDetails, element: <CompanyItemDetails /> },
  { path: routes.companyReportStages, element: <CompanyItemStart /> },
  { path: routes.companyReportStage, element: <SiphoningStep /> },

  // GOVERMENT PAGES
  { path: routes.goverment, element: <Company /> },

  // REPORTS PAGES
  { path: routes.reportsList, element: <ReportList /> },
  { path: routes.reports, element: <Company /> },
  { path: routes.reportItemDetails, element: <ReportItemDetails /> },
  { path: routes.siphoningSummary, element: <SiphoningSummary /> },
  { path: routes.taskSummaryNotes, element: <SummaryNotes /> },
  { path: routes.sync, element: <Sync /> },
];

export const invalidRoutes = [
  { path: "*", element: <LoginPage /> },
  { path: routes.login, element: <LoginPage /> },
];
